import { render, staticRenderFns } from "./MusicDatabase.vue?vue&type=template&id=6346af1c&scoped=true&"
import script from "./MusicDatabase.vue?vue&type=script&lang=js&"
export * from "./MusicDatabase.vue?vue&type=script&lang=js&"
import style0 from "./MusicDatabase.vue?vue&type=style&index=0&id=6346af1c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../voicecasting.sk/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6346af1c",
  null
  
)

export default component.exports